// extracted by mini-css-extract-plugin
export default {"cancelTicket":"flex_cancelTicket__CP+EH","wrapper":"flex_wrapper__Vu2lZ"};